<template>
  <div class="ms-form ms-form--narrow">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid ms-form-grid--single">
        <CustomDate
          label="Утвердить для даты"
          required="true"
          :value="this.formData.date_shipping_plan"
          @change_date="(value) => (this.formData.date_shipping_plan = value)"
          full-width="true"
        />
      </div>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomDate from "@/components/form/CustomDate";


export default {
  name: "provider-requests-contractor-approve",
  components: { CustomModalFooter, CustomDate },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        provider_request_id_arr: this.data.body?.provider_request_id_arr || [],
        date_shipping_plan: '',
      },
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
  },
}
</script>
